var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12C20 14.1218 19.1571 16.1566 17.6569 17.6569C16.1566 19.1572 14.1217 20 12 20C9.87827 20 7.84344 19.1572 6.34315 17.6569C4.84285 16.1566 4 14.1218 4 12C4 9.87831 4.84285 7.84348 6.34315 6.34319C7.84344 4.8429 9.87827 4.00004 12 4.00004C12.76 4.00004 13.5 4.11004 14.2 4.31004L15.77 2.74004C14.5743 2.24761 13.2931 1.99613 12 2.00004C10.6868 2.00004 9.38642 2.2587 8.17317 2.76125C6.95991 3.2638 5.85752 4.00039 4.92893 4.92898C3.05357 6.80434 2 9.34788 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7363 8.17317 21.2388C9.38642 21.7414 10.6868 22 12 22C14.6522 22 17.1957 20.9465 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12M7.91 10.08L6.5 11.5L11 16L21 6.00004L19.59 4.58004L11 13.17L7.91 10.08Z",
    fill: "#221C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.c363790d5c1c004ef6841acab29f1da9.svg";
export { ForwardRef as ReactComponent };